// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationTouchIdPath = 'M61 14.325a49.6 49.6 0 0126.2 15.2l5.2-4.7a57.4 57.4 0 00-29.9-17.4 58.2 58.2 0 00-25.6 0A57.4 57.4 0 007 24.825l5.2 4.7a49.6 49.6 0 0126.2-15.2 50.7 50.7 0 0122.6 0zM7.5 43.599l6.1 3.4a41.5 41.5 0 0171.9-.5l6-3.6a48.5 48.5 0 00-84 .7zm51.9 50.654l-4.3-5.5.047-.04c.793-.668 11.153-9.394 11.153-21.76a18.2 18.2 0 00-1.5-6.9 16.6 16.6 0 00-31.7 6.9h-7a23.6 23.6 0 0118.578-22.91A23.6 23.6 0 0171.1 57.153a23.8 23.8 0 012.2 9.8c0 15.875-12.77 26.372-13.849 27.258l-.051.042zm-21.7-4.546l1.2 3.3c.9-.3 21.9-8.2 21.9-26a11.9 11.9 0 00-1-4.6 11.2 11.2 0 00-10.1-6.5 11.1 11.1 0 00-10.2 6.7 10.8 10.8 0 00-.9 4.4 7.6 7.6 0 01-7.6 7.6h-2.7a7.6 7.6 0 01-7.6-7.6 28.2 28.2 0 012.4-11.5 29 29 0 0153-.6 29.6 29.6 0 01-.3 24.9l6.2 3.1a35 35 0 003.7-15.9 36.7 36.7 0 00-3.2-15 36.1 36.1 0 00-65.9.7 36.5 36.5 0 00-2.9 14.3c0 8.063 6.537 14.6 14.6 14.6H31c8.063 0 14.6-6.537 14.6-14.6a4.101 4.101 0 01.3-1.6 4.3 4.3 0 013.8-2.5 4.2 4.2 0 013.7 2.4 3.5 3.5 0 01.4 1.7c0 12.9-17.2 19.4-17.3 19.4l1.2 3.3z';
var IllustrationTouchId = baseIllustration('IllustrationTouchId', {
  getPath: () => IllustrationTouchIdPath
}, 'ColoredIllustrationTouchID');
IllustrationTouchId.displayName = 'IllustrationTouchID';

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationTouchId;
//# sourceMappingURL=index.js.map